import type { LibraryBlockApiEntity, UnsavedLibraryBlockEntity } from './library-blocks.models';

import { createAction, props } from '@ngrx/store';

export const initLibraryBlocks = createAction('[LibraryBlocks Admin Page] Init');

export const initUserLibraryBlocks = createAction('[LibraryBlocks User Page] Init');

export const loadLibraryBlocksSuccess = createAction(
    '[LibraryBlocks/API] Load LibraryBlocks Success',
    props<{ libraryBlocks: LibraryBlockApiEntity[] }>()
);

export const loadLibraryBlocksFailure = createAction(
    '[LibraryBlocks/API] Load LibraryBlocks Failure',
    props<{ error: any }>()
);

export const upsertLibraryBlock = createAction(
    '[LibraryBlocks] Upsert LibraryBlock',
    props<{ libraryBlock: UnsavedLibraryBlockEntity; skipCreate?: boolean }>()
    // skipCreate is for the case when we upserting library block that was created by user (not in admin area)
);

export const removeLibraryBlock = createAction('[LibraryBlocks] Remove LibraryBlock', props<{ blockId: string }>());

export const markAsDeleted = createAction('[LibraryBlocks] Mark LibraryBlock as Deleted', props<{ blockId: string }>());

export const proceedLibraryBlocks = createAction('[LibraryBlocks] Proceed LibraryBlocks');
